import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["short", "full"]

  expand() {
    this.shortTarget.classList.add("hidden")
    this.fullTarget.classList.remove("hidden")
  }

  collapse() {
    this.fullTarget.classList.add("hidden")
    this.shortTarget.classList.remove("hidden")
  }
}
